// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How a template entry is expanded across a bank's floors.
 *
 * An entry is authored once and becomes one literal entry per floor when
 * `LiftCloud` builds the bank's CDO, so `Traffic::P` (or any message that
 * carries a position) is mapped once instead of once per floor.
 *
 * Floor `i` runs `0..span-1`, where `span` is the bank's floor-index span (the
 * same span LN1 floor expansion uses). The emitted LN2 `position` is `i`.
 */
export enum FloorExpansionMode {
  None_ = 0,

  /**
   * The node id is fixed and the wire VALUE varies per floor: floor `i`
   * matches the value `i + value_base`, in the `Data` variant authored on the
   * template (variants are NOT interchangeable on the wire: I32(2) != U16(2)).
   */
  DataOnly = 1,

  /**
   * The wire value is fixed and the node id varies per floor: every `{floor}`
   * in a string node identifier is replaced with `i + path_base`.
   */
  PathOnly = 2,

  /**
   * Both axes vary together.
   */
  PathAndData = 3,
}
